export default __webpack_public_path__ + "assets/097577cf368b328ecd26ec978d54fbaa.svg";